import request from '@/utils/kiosk-request'

export function getDownloadBanner(data) {
  return request({
    url: `/cotti-kapi/customer/position/list`,
    method: 'POST',
    data
  })
}
export function checkUpdate(data) {
  return request({
    url: '/cotti-kapi/ota/checkUpdate',
    method: 'POST',
    data
  })
}
